import { Injectable, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from "../models/UserObj";
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { AuthService } from './../services/auth.service';
import { Observable } from 'rxjs'
import { CommonService } from './../services/common.service'

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(private inj: Injector,
        private _commonService: CommonService,
        private router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const auth = this.inj.get(AuthService);

        let user: User = <User>this._commonService.getUser();
        if (user && user.UserId) {
            request = request.clone({
                setHeaders: {
                    UserId: user.UserId.toString(),
                    UserName: user.UserName,
                    Token: user.Token,
                    UserEmail : user.Email
                }
            });
        }
        else {
            request = request.clone();
        }

        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                //console.log(event);
                // do stuff with response if you want
            }
        }, (err:any) => {
            console.log('error', err);
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    // redirect to the login route
                    console.log("User is not authorized, Redirecting to Home screen.")
                    this.router.navigate(["/home"]);
                }
                else if (err.status === 417) {
                    // redirect to the login route
                    // or show a modal
                    console.log("User's Token has expired, User must login again.")
                    auth.logout();
                    this.router.navigate(["/login"]);
                }
                else if (err.status === 500) {
                    //raise a toatr or redirect to Error page
                    return Observable.throw(err);
                }
                else if (err.status === 0) {
                    return Observable.throw(err);
                }
            }
        });

    }
}


// WEBPACK FOOTER //
// ./src/app/interceptors/request.interceptor.ts